import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_CONFIG_DETAILS } from './url-constants';

type ManageAlarmsConfigDetailsEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsConfigDetailsEndpointSpecification: ManageAlarmsConfigDetailsEndpointSpecification = {
    url: MANAGE_ALARM_CONFIG_DETAILS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'ManageAlarmsConfigDetailsRequestParams',
    requestBodySchemaName: 'ManageAlarmsConfigDetailsRequestBody',
    okResponseSchemaName: 'ManageAlarmsConfigDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmsConfigDetails = Helpers.makeApiRequestFn<
    Types.ManageAlarmsConfigDetailsRequestParams,
    Types.ManageAlarmsConfigDetailsRequestBody,
    Types.ManageAlarmsConfigDetailsOkResponse
>(ManageAlarmsConfigDetailsEndpointSpecification);
